import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.5_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.77.8/node_modules/next/dist/client/link.js");
